const getters = {
  getProgress: (state) => {
    let arrayOfCargos = _.toArray(state.progress)
     return _.orderBy(arrayOfCargos, ['estimatedTimeOfDeparture.seconds'], ['asc'])
  },
    getProgressOfCargo: (state) => (cargoId) => {
        let arrayOfCargos = _.toArray(state.progress)
        return _.find(arrayOfCargos, { 'id': cargoId }) || {
            // Placeholder for when the store isnt opened yet
            progress: {
                available: 0,
                loaded: 0,
                notAvailable: 0,
                totalAmount: 0,
                unknownBarcode: 0
            }
        }
    },
}

export default getters